export default __webpack_public_path__ + "static/media/Erin Atacan.36e07402.png";